import { twMerge } from "tailwind-merge";
import { TwoColumnsLayoutBase, type TwoColumnsLayoutBaseProps } from "@core/ui";

export type Props = Omit<TwoColumnsLayoutBaseProps, "data-testid" | "leftClassName" | "rightClassName"> & {
  /** Layout variant */
  layout?: "even" | "wide-left" | "wide-right";
};

/**
 * Styled two-column layout component wrapping TwoColumnsLayoutBase.
 * Provides configurable column widths.
 */
export function TwoColumnsLayout({ children, layout = "wide-left", className, ...props }: Props) {
  const leftClassName = twMerge(
    "w-full",
    layout === "wide-left" && "flex-2 max-w-2xl",
    layout === "wide-right" && "flex-1 max-w-xs",
    layout === "even" && "flex-1"
  );

  const rightClassName = twMerge(
    "w-full",
    layout === "wide-left" && "flex-1 md:max-w-xs",
    layout === "wide-right" && "flex-2 md:max-w-2xl",
    layout === "even" && "flex-1"
  );

  return (
    <TwoColumnsLayoutBase
      className={twMerge("flex flex-col lg:flex-row gap-12 w-full", className)}
      leftClassName={leftClassName}
      rightClassName={rightClassName}
      data-testid="two-columns-layout"
      {...props}
    >
      {children}
    </TwoColumnsLayoutBase>
  );
}

export default TwoColumnsLayout;

